import React from "react";
import moment from "moment"
import { ImWarning } from "react-icons/im";

const Widget = ({ title, items, subtitle }) => {
  return (
    <div className="shadow-lg px-4 py-6 w-full bg-white dark:bg-gray-800 rounded-xl">
      <p className="text-sm w-max text-gray-700 dark:text-white font-semibold border-b border-gray-200">
        {title} { subtitle && <small>{subtitle}</small>}
      </p>
      <div className="flex items-end space-x-2 my-6">
        <p className="text-5xl text-black dark:text-white font-bold">
          {items.length}
        </p>
      </div>
      <div className="dark:text-white">
      {
        items.slice(0, 3).map(({ id, customerName, numberPlate, createdAt, status, pendingAt, endedAt, customerBusiness }) => (
          <div key={id} className="flex items-center pb-2 mb-2 text-sm space-x-12 md:space-x-24 justify-between border-b border-gray-200">
            <p>
              {customerName}
              { customerBusiness &&  <span className='ml-1 text-yellow-600'>Pro</span> }
              <br/>
              <small>{numberPlate}</small>
            </p>
            <div className="flex items-end text-xs text-gray-500">
              { status === "new" && createdAt && moment(createdAt.toDate()).calendar()}
              { status === "pending" && pendingAt && moment(pendingAt.toDate()).calendar()}
              { status === "ended" && endedAt && moment(endedAt.toDate()).calendar()}
            </div>
          </div>
        ))
      }
      {
        items.length === 0 && <div className='text-center'>
          <ImWarning className="h-10 w-10 p-2 mx-auto mb-2 text-yellow-300" />
          <p>Aucune donnée</p>
        </div>
      }
      </div>
    </div>
  );
}

export default Widget